import { useTranslation } from 'react-i18next';

import type { ProductStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const STYLES: Record<ProductStatus, string> = {
  active: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  draft: 'bg-secondary text-secondary-foreground border-transparent',
  archived: 'border-border text-muted-foreground',
};

/** Tinted pill: green for active, neutral for draft, outlined for archived. */
export function ProductStatusBadge({
  status,
  className,
}: {
  status: ProductStatus;
  className?: string;
}) {
  const { t } = useTranslation('common');
  return (
    <Badge variant="outline" className={cn(STYLES[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
